<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
            <div class="modal-container" style="max-height:100vh;overflow-y:scroll;">

              <div class="modal-header">
                <slot name="header">
                  USER DETAILS
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  User Email
                  <div class="input-box">
                    <input type="text" v-model="newUser.email">
                  </div>
                  Tick the permission required
                  <div class="input-box">
                    <input type="checkbox" id="admin" value="admin" v-model="newUser.permission">
                    <label for="admin">admin</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="role-editor" value="editor" v-model="newUser.permission">
                    <label for="role-editor">editor</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="podcast" value="podcast" v-model="newUser.permission">
                    <label for="podcast">podcast</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="video" value="video" v-model="newUser.permission">
                    <label for="video">video</label>
                  </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button" @click="addNewUser">
                    ADD USER
                  </button>
                  <button class="modal-default-button" @click="closeTheModal">
                    CANCEL
                  </button>
                </slot>
              </div>
            </div>
            </div>
        </div>
    </transition>
</template>

<script>
//import request from "axios";
import Vue from "vue";
import firebase from 'firebase';
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
  export default {
    name: 'modal',
    // props: {
    //   passedObject: {
    //       type: Object
    //   }
    // },
    firestore() {
      return {
      };
    },
    data: function() {
      firestore = firebase.firestore();
      return {
        newUser: {
          admin: false,
          email:"",
          permission:[]
        },
      }
    },
    methods: {
      addNewUser() {
        firestore
          .collection("users")
          .add(this.newUser);
        alert("User created");
        this.newUser = {
          admin: false,
          email:"",
          permission:[]
        };
        this.$emit('update:modal');
    },
      closeTheModal() {
        this.$emit('update:modal');
     }

    }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}

</style>

<style scoped>
.flex-row {
  display:flex;
}
input {
  display:block;
}
.modal-mask {
  overflow-y:scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  color:#000000;
  text-align:center;
}

.modal-body {
  margin: 20px 0;
  color:#000000;
}

.modal-default-button {
  float: right;
}
.modal-footer {
  padding:10px;
}
.modal-footer button {
  margin-right:10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>



// WEBPACK FOOTER //
// ModalUser.vue?11bb0d8e